<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h3 class="mb-0">TikTok Ads theo Merchant</h3>
    </div>

    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-3">
          <label class="form-label">Chọn Tài khoản</label>
          <ng-select
            [(ngModel)]="selectedMerchantId"
            [items]="merchantOptions"
            bindLabel="name"
            bindValue="merchantId"
            placeholder="Tìm và chọn khoản..."
            [clearable]="true"
            [searchable]="true"
            (change)="onSearch()">
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Loại Tài khoản</label>
          <ng-select
            [(ngModel)]="selectedMerchantType"
            [items]="merchantTypeOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Chọn loại tài khoản..."
            [clearable]="true"
            [searchable]="false"
            (change)="onMerchantTypeChange()">
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Seller</label>
          <ng-select
            [(ngModel)]="selectedGroupId"
            [items]="groupOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Chọn seller..."
            [clearable]="true"
            [searchable]="true"
            (change)="onGroupChange()">
          </ng-select>
        </div>
        
      </div>

      <div class="row mb-3">
        <div class="col-md-3">
          <div class="stat-box stat-running">
            <div class="label">Đang chạy</div>
            <div class="value">{{ formatWithPercent(filteredSummary.running, filteredSummary.total) }}</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="stat-box stat-partial">
            <div class="label">Chạy một phần</div>
            <div class="value">{{ formatWithPercent(filteredSummary.partial, filteredSummary.total) }}</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="stat-box stat-not-running">
            <div class="label">Không chạy</div>
            <div class="value">{{ formatWithPercent(filteredSummary.notRunning, filteredSummary.total) }}</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="stat-box stat-total">
            <div class="label">Tổng</div>
            <div class="value">{{ filteredSummary.total }}</div>
          </div>
        </div>
      </div>

      <div *ngIf="isLoading" class="alert alert-info">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Đang tải trạng thái merchant...
      </div>

      <div class="table-responsive" *ngIf="!isLoading">
        <table class="table table-hover">
          <thead>
            <tr>
              <th role="button" (click)="toggleSort('name')">
                Merchant
                <i class="fas ms-1" [ngClass]="sortIcon('name')"></i>
              </th>
              <th role="button" (click)="toggleSort('type')">
                Loại
                <i class="fas ms-1" [ngClass]="sortIcon('type')"></i>
              </th>
              <th role="button" (click)="toggleSort('running')">
                Đang chạy
                <i class="fas ms-1" [ngClass]="sortIcon('running')"></i>
              </th>
              <th role="button" (click)="toggleSort('partial')">
                Chạy một phần
                <i class="fas ms-1" [ngClass]="sortIcon('partial')"></i>
              </th>
              <th role="button" (click)="toggleSort('notRunning')">
                Không chạy
                <i class="fas ms-1" [ngClass]="sortIcon('notRunning')"></i>
              </th>
              <th role="button" (click)="toggleSort('total')">
                Tổng
                <i class="fas ms-1" [ngClass]="sortIcon('total')"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="filteredRows.length === 0">
              <td colspan="6" class="text-center text-muted">Không tìm thấy merchant nào.</td>
            </tr>
            <tr *ngFor="let row of filteredRows" style="cursor: pointer;" (click)="openMerchantInTikTokAds(row)">
              <td>{{ row.name }}</td>
              <td>{{ row.type }}</td>
              <td class="text-success fw-semibold">{{ formatRowWithPercent(row.running, row.total) }}</td>
              <td class="text-warning fw-semibold">{{ formatRowWithPercent(row.partial, row.total) }}</td>
              <td class="text-danger fw-semibold">{{ formatRowWithPercent(row.notRunning, row.total) }}</td>
              <td class="text-primary fw-semibold">{{ row.total }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
